import { z } from 'zod';

export const idSchema = z.string().min(1);
export type Id = z.infer<typeof idSchema>;

export const isoDateSchema = z.iso.date();
export type IsoDate = z.infer<typeof isoDateSchema>;

export const isoDateTimeSchema = z.iso.datetime({ offset: true });
export type IsoDateTime = z.infer<typeof isoDateTimeSchema>;

// Integer minor units (cents), like Stripe, so sums never pick up floating point errors.
export const amountSchema = z.int();
export type Amount = z.infer<typeof amountSchema>;

// ISO 4217, e.g. 'EUR', 'USD'
export const currencySchema = z.string().length(3);
export type Currency = z.infer<typeof currencySchema>;

// oklch hue (0–359) of the avatars of workspaces; null leaves them grey.
export const avatarHueSchema = z.int().min(0).max(359);

// What the API's lists answer per page, unless they're asked for another `page_size` (api/core/pagination.py).
export const PAGE_SIZE = 50;
export const MAX_PAGE_SIZE = 200;
